<template>
  <v-card elevation="0" class="pa-2"> </v-card>
</template>

<script>
export default {
  name: "commercialListItemSevenAdmin",
};
</script>

<style></style>
